import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: "I went from waking up at 3 AM with doubts about my future, to having a financial plan and a real support network in less than a month. 'The Secure Woman' gave me the structure that no book ever had.",
    author: 'Jennifer R.',
    age: '42 years old',
    location: 'Miami, FL'
  }, {
    quote: 'At 39, I thought my time had passed. This program taught me that my autonomy is my greatest asset. Now my relationships come from choice, not from need.',
    author: 'Michelle S.',
    age: '35 years old',
    location: 'Los Angeles, CA'
  }];
  return <section className="bg-cream py-24" data-id="element-120">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-122">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-navy-900 mb-4" data-id="element-123">
            Women who already took control
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-124"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-125">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white p-8 sm:p-10 rounded-2xl shadow-lg border border-cream-warm relative" data-id="element-126">
              <div className="absolute top-6 right-8 text-gold/20 text-6xl font-serif leading-none" data-id="element-127">
                "
              </div>

              <div className="flex gap-1 mb-6" data-id="element-128">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-129" />)}
              </div>

              <p className="text-lg text-navy-800 italic mb-8 relative z-10 leading-relaxed" data-id="element-130">
                "{testimonial.quote}"
              </p>

              <div className="border-t border-cream-warm pt-4" data-id="element-131">
                <p className="font-bold text-navy-900" data-id="element-132">{testimonial.author}</p>
                <p className="text-sm text-navy-700" data-id="element-133">
                  {testimonial.age} | {testimonial.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}